import { configureStore } from "@reduxjs/toolkit";

import authReducer from "../reducer/authSlice";
import jobReducer from "../reducer/jobSlice";
import fresherProfileReducer from "../reducer/fresherProfileSlice";
import usersReducer from "../reducer/usersSlice";
import userProfileReducer from "../reducer/profileSlice";
import projectsSliceReducer from "../reducer/projectsSlice";
import postsSliceReducer from "../reducer/postsSlice";
import requestEmailReducer from "../reducer/requestEmailSlice";
import notificationSlice from "../reducer/notificationSlice";
import paymentSlice from "reducer/paymentSlice";
import globalSlice from "reducer/globalSlice";

const store = configureStore({
  reducer: {
    global: globalSlice,
    auth: authReducer,
    jobs: jobReducer,
    fresherProfile: fresherProfileReducer,
    users: usersReducer,
    userProfile: userProfileReducer,
    projects: projectsSliceReducer,
    posts: postsSliceReducer,
    requestEmail: requestEmailReducer,
    notifications: notificationSlice,
    payment : paymentSlice,
  },
});

export default store;
